
import React from "react";
import * as react from "react";
import { map, defaultArg } from "../../fable_modules/fable-library-js.5.0.0/Option.js";
import { FSharpMap__TryFind } from "../../fable_modules/fable-library-js.5.0.0/Map.js";
import { empty } from "../../fable_modules/fable-library-js.5.0.0/List.js";
import { Tooltip } from "react-leaflet";

export function Tooltip_View($props) {
    const p = $props.p;
    const props = {};
    const children = defaultArg(map((x) => x, FSharpMap__TryFind(p, "children")), empty());
    return react.createElement(Tooltip, props, ...children);
}

